
import Vue100vh from 'vue-100vh'

export default {
  components: { Vue100vh },
}
